var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M12,0C5.373,0,0,5.373,0,12c0,6.628,5.373,12,12,12c6.628,0,12-5.372,12-12C24,5.373,18.628,0,12,0z  M12,20.4c-4.639,0-8.4-3.76-8.4-8.4c0-4.639,3.761-8.4,8.4-8.4s8.4,3.761,8.4,8.4S16.641,20.4,12,20.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DAFD82",
    d: "M13.875,6h-3.75v4.125v3.75h3.75H18v-3.75h-4.125V6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorClock);
export default __webpack_public_path__ + "static/media/color-clock.6168f65568755b44524d17e943970e7b.svg";
export { ForwardRef as ReactComponent };